<template>
    <div class="grupos">
        <h2 class="subheading grey--text">{{$t('grupos')}}</h2>

        <v-container class="my-5">
            <v-layout align-center justify-center fill-height>
                <v-dialog v-model="dialog" persistent max-width="600px">
                    <template
                            v-slot:activator="{ on }">
                        <v-btn
                                color="primary"
                                dark v-on="on"
                                @click="update = false, clean_fields()">
                            <v-icon>group_add</v-icon>{{$t('anadir_grupo')}}
                        </v-btn>
                    </template>
                    <v-flex>
                        <v-card class="elevation-5">
                            <v-toolbar class="mb-5" dark color="primary">
                                <v-toolbar-title>
                                    {{$t('grupos')}}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-card-text>
                                <v-form
                                        class="mb-4"
                                        @submit.prevent="update
                                        ? update_grupo(id_update)
                                        : alta_grupo()">
                                    <v-text-field
                                            v-model="nombre"
                                            v-if="dialog" autofocus
                                            prepend-icon="person"
                                            name="nombre"
                                            :label="$t('nombre')"
                                            :error-messages="errores.nombre"
                                    >
                                    </v-text-field>
                                    <v-alert
                                            :value=alerta
                                            type="warning"
                                            outline
                                            transition="scale-transition"
                                    >
                                        Fallo con el Servidor
                                    </v-alert>

                                    <v-btn
                                            color="primary"
                                            @click="clear(),
                                            dialog = false"
                                    >{{this.$t('cerrar')}}
                                    </v-btn>
                                    <v-btn
                                            v-if="update"
                                            color="primary"
                                            type="submit"
                                    >{{this.$t('modificar')}}
                                    </v-btn>
                                    <v-btn
                                            v-else
                                            color="primary"
                                            type="submit"
                                    >{{this.$t('agregar')}}
                                    </v-btn>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-dialog>
                <v-dialog v-model="dialog2" persistent max-width="600px">
                    <v-flex>
                        <v-card class="elevation-5">
                            <v-toolbar class="mb-5" dark color="primary">
                                <v-toolbar-title>
                                    {{$t('contactosXgrupo')}}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn color="red" icon dark @click="clear(), dialog2 = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-form
                                        class="mb-4"
                                        @submit.prevent="alta_contactoXgrupo(id_grupo, id_contacto)">
                                    <v-autocomplete

                                            v-model="id_contacto"
                                            v-if="dialog2" autofocus
                                            prepend-icon="person"
                                            name="id_contacto"
                                            :item-text="example"
                                            item-value="id"
                                            :label="$t('contactos')"
                                            :error-messages="errores.id_contacto"
                                            :items="contactos"
                                            :no-data-text="$t('no_resultados')"
                                            :search-input.sync="search1"

                                    >
                                    </v-autocomplete>
                                    <v-alert
                                            :value=alerta
                                            type="warning"
                                            outline
                                            transition="scale-transition"
                                    >
                                        Fallo con el Servidor
                                    </v-alert>
                                    <v-btn
                                            color="primary"
                                            type="submit"
                                    >{{this.$t('agregar')}}
                                    </v-btn>
                                </v-form>
                                <v-data-table
                                        :headers="headers2"
                                        :loading="loading_data_contactos_grupos"
                                        :items="contactosXgrupo"
                                        :rows-per-page-text="$t('filas_por_pagina')"
                                        :rows-per-page-items="[
                            {text: '5', value: 5},
                            {text: '10', value: 10},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"

                                >
                                    <template v-slot:items="props">
                                        <td align="center">
                                            <v-icon
                                                    medium
                                                    class="mr-2"
                                                    color="red"
                                                    @click="eliminarContactoXGrupo(props.item.id_grupo, props.item.id_contacto)"
                                            >
                                                delete
                                            </v-icon>
                                        </td>
                                        <td>{{ props.item.nombre_usuario }} {{props.item.apellido_usuario}}</td>
                                        <td>{{ props.item.celular_usuario }}</td>
                                        <td>{{ props.item.email_usuario}}</td>
                                    </template>
                                    <!--<template v-slot:no-results>-->
                                    <!--<v-alert :value="true" color="error" icon="warning">-->
                                    <!--{{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}-->
                                    <!--</v-alert>-->
                                    <!--</template>-->
                                    <template v-slot:pageText="props">
                                        {{props.rowsPerPage}}
                                        {{$t('contactos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-dialog>
            </v-layout>

            <v-layout row wrap class="my-4" justify-center fill-height>
                <v-flex xs12 sm6 class="pr-3">
                    <v-card-title>
                        {{$t('grupos')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loading_data_grupos"
                            :items="grupos"
                            :search="search"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :rows-per-page-items="[
                            {text: '5', value: 5},
                            {text: '10', value: 10},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"

                    >
                        <template v-slot:items="props">
                            <td align="center">
                                <v-icon
                                        medium
                                        @click="fill_fields(props.item),
                                        update = true,
                                        dialog = true,
                                        id_update = props.item.id"
                                >
                                    edit
                                </v-icon>
                            </td>
                            <td align="center">
                                <v-icon
                                        medium
                                        color="red"
                                        @click="eliminarGrupo(props.item.id)"
                                >
                                    delete
                                </v-icon>
                            </td>
                            <td>{{ props.item.nombre }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('grupos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
                <v-flex xs12 sm6 class="pr-3">
                    <v-card
                            class="mx-auto"
                            max-width="300"
                            tile
                    >
                        <v-list shaped>
                            <v-subheader>{{$t('grupos')}}</v-subheader>
                            <v-list-item-group color="primary">
                                <v-btn
                                        v-for="(item, i) in grupos"
                                        :key="i"
                                        @click="dialog2 = true, get_contactosXgrupo(item.id), id_grupo = item.id"
                                >
                                    <v-list-item-icon>
                                        <v-icon>person_add</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{item.nombre}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-btn>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    Vue.use(VeeValidate)
    import { mapState } from 'vuex'
    import { mapGetters } from 'vuex'

    export default {
        name: "grupos",
        data: () => ({
            alerta: false,
            dialog: false,
            dialog2: false,
            update: false,
            id_update: 0,
            nombre: '',
            errores: [],
            headers: [],
            headers2: [],
            grupos: [],
            item: 1,
            loading_data_grupos: false,
            loading_data_contactos_grupos: false,
            contactos:[],
            contactosXgrupo:[],
            id_grupo: 0,
            search:'',
            search1: ''
        }),
        beforeUpdate(){
            this.headers = [
                {
                    text: this.$t('modificar'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('eliminar'),
                    align: 'center',
                    sortable: false,
                    value: 'delete'
                },
                {
                    text: this.$t('nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                }
            ],
                this.headers2 = [
                    {
                        text: this.$t('eliminar'),
                        align: 'left',
                        sortable: false,
                        value: 'update'
                    },
                    {
                        text: this.$t('nombre'),
                        align: 'left',
                        sortable: true,
                        value: 'nombreContacto'
                    },
                    {
                        text: this.$t('celular'),
                        align: 'left',
                        sortable: true,
                        value: 'celular_usuario'
                    },
                    {
                        text: 'E-mail',
                        align: 'left',
                        sortable: true,
                        value: 'email_usuario'
                    }
                ]
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['language']),
            filter () {
                return this.caseSensitive
                    ? (item, search, textKey) => item[textKey].indexOf(search) > -1
                    : undefined
            },
        },
        created: function(){
            this.get_grupos()
            // this.get_contactos('444')
        },
        watch: {
            search1 (val) {
                // Items have already been loaded
                //if (this.items.length > 0) return

                // Items have already been requested
                //if (this.isLoading) return
                if (val.length > 2){

                    // this.isLoading = true

                    // Lazily load input items
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/users/filter?search=' + val,
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    };
                    axios(config)
                        .then(response => {
                            // console.log(response.data)
                            this.contactos = response.data
                        })
                        .catch(error => {
                            console.log(error)
                        });
                        // .finally(() => (this.isLoading = false))
                }

            }
        },
        methods: {
            get_grupos: function(){
                this.loading_data_grupos = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/grupos',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.grupos= response.data
                        this.loading_data_grupos = false
                    })
                    .catch(error => {
                        this.loading_data_grupos = false
                        console.log(error)
                    })
            },
            get_contactos: function(value){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/users/filter?search=' + value,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.contactos= response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            get_contactosXgrupo: function(id_grupo){
                this.loading_data_contactos_grupos = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/grupos/contacts_grupos/' + id_grupo,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.contactosXgrupo= response.data
                        this.loading_data_contactos_grupos = false
                    })
                    .catch(error => {
                        this.loading_data_contactos_grupos = false
                        console.log(error)
                    })

            },
            alta_contactoXgrupo: function (id_grupo, id_contaco) {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/grupos/contacts_grupo',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                id_grupo: id_grupo,
                                id_contacto: id_contaco,
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_contactoXgrupo_alta'))
                                this.get_contactosXgrupo(this.id_grupo)
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });

            },
            eliminarContactoXGrupo: function (id_grupo, id_contacto_grupo){
                console.log('Eliminar')
                const config = {
                    method: 'delete',
                    url: 'https://empresa-service.intrare.app/grupos/contacts_grupos/' + id_grupo + '/delete/' + id_contacto_grupo,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.get_contactosXgrupo(this.id_grupo)
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'warning')
                        this.$store.commit('snackbar_change_message', this.$t('mensaje_contactoXgrupo_delete'))
                        setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            eliminarGrupo: function (id_grupo){
                console.log('Eliminar Grupo')
                const config = {
                    method: 'delete',
                    url: 'https://empresa-service.intrare.app/grupos/' + id_grupo + '/delete',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.get_grupos(this.id_grupo)
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'warning')
                        this.$store.commit('snackbar_change_message', this.$t('mensaje_grupo_delete'))
                        setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            alta_grupo: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/grupos',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                nombre: this.nombre
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_grupo_alta'))
                                this.get_grupos()
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });

            },
            update_grupo: function (id) {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        const config = {
                            method: 'put',
                            url: 'https://empresa-service.intrare.app/grupos/' + id + '/update',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                nombre: this.nombre,
                                telefono: this.celular,
                                email: this.email
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.get_grupos()
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_grupo_modificado'))
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.$validator.reset()
                this.id_contacto = ''
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
            },
            fill_fields(item){
                this.nombre = item.nombre
                this.celular = item.telefono
                this.email = item.email
            },
            clean_fields(){
                this.nombre = ''
                this.celular = ''
                this.email = ''
            },
            getList  (item, queryText, itemText) {
                // alert('HOLA')
                return itemText.toLocaleLowerCase().startsWith(queryText.toLocaleLowerCase())
            },
            remove: function(item) {
                const index = this.id_contacto.indexOf(item.id)
                if (index >= 0) this.id_contacto.splice(index, 1)
            },
            example: item => item.email + ' - ' + item.celular,
        }
    }
</script>

<style scoped>

</style>
